import PropTypes from 'prop-types';

import FloatingDateInput from '#/modules/commonComponents/form/FloatingDateInput';
import FloatingTextarea from '#/modules/commonComponents/form/FloatingTextarea';
import { SelectCore } from '#/modules/commonComponents/form/select';

const StockReturnOperateHeader = ({
  warehouseOptions = [],
  sourceWarehouseId,
  targetWarehouseId,
  onSourceWarehouseChange,
  onTargetWarehouseChange,
  returnDate = '',
  onReturnDateChange,
  issueReason = '',
  onIssueReasonChange,
  remark = '',
  onRemarkChange,
  isWarehouseLoading = false,
  isSourceWarehouseLocked = false,
}) => (
  <section className="pb-6">
    <h2 className="form-block__title mb-5!">操作設定</h2>
    <div className="grid grid-cols-1 gap-3 @4xl/sheet:grid-cols-2">
      <FloatingDateInput
        id="returnDate"
        label="退料日"
        value={returnDate}
        onChange={onReturnDateChange}
        containerClassName="@4xl/sheet:col-span-2 mb-0!"
      />
      <SelectCore
        id="returnSourceWarehouse"
        label="來源倉"
        options={warehouseOptions}
        value={sourceWarehouseId}
        onChange={onSourceWarehouseChange}
        isDisabled={isWarehouseLoading || isSourceWarehouseLocked}
        noOptionsMessage="無可用倉別"
      />
      <SelectCore
        id="returnTargetWarehouse"
        label="目標倉"
        options={warehouseOptions}
        value={targetWarehouseId}
        onChange={onTargetWarehouseChange}
        isDisabled={isWarehouseLoading}
        noOptionsMessage="無可用倉別"
      />
      <FloatingTextarea
        id="returnIssueReason"
        label="事由"
        value={issueReason}
        onChange={(event) => onIssueReasonChange(event.target.value)}
      />
      <FloatingTextarea
        id="returnRemark"
        label="備註"
        rows={2}
        value={remark}
        onChange={(event) => onRemarkChange(event.target.value)}
        containerClassName="@4xl/sheet:col-span-1 mb-0!"
      />
    </div>
    <p className="mt-3 text-xs text-muted-foreground">
      選來源倉後載入該倉可用庫存（依物料群組）；選庫加入明細後送出建立退料單。
    </p>
  </section>
);

StockReturnOperateHeader.propTypes = {
  warehouseOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  sourceWarehouseId: PropTypes.string,
  targetWarehouseId: PropTypes.string,
  onSourceWarehouseChange: PropTypes.func.isRequired,
  onTargetWarehouseChange: PropTypes.func.isRequired,
  returnDate: PropTypes.string,
  onReturnDateChange: PropTypes.func.isRequired,
  issueReason: PropTypes.string,
  onIssueReasonChange: PropTypes.func.isRequired,
  remark: PropTypes.string,
  onRemarkChange: PropTypes.func.isRequired,
  isWarehouseLoading: PropTypes.bool,
  isSourceWarehouseLocked: PropTypes.bool,
};

export default StockReturnOperateHeader;
